import { render, staticRenderFns } from "./GrossingIndex.vue?vue&type=template&id=2e3901ce&"
import script from "./GrossingIndex.vue?vue&type=script&lang=js&"
export * from "./GrossingIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports